
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {
	const blockProps = useBlockProps({
		className: 'c4l-due-date'
	});
	const { attributes, setAttributes } = props;
	const { content } = attributes;

	return (
		<div {...blockProps}>
			<RichText
				tagName='div'
				className='c4l-due-date-content'
				value={content}
				onChange={(newVal) => setAttributes({ content: newVal })}
				placeholder={__('Month 1st', 'due-date')}
			/>
		</div>
	);
}
